import axios from '@/utils/axios'
import { DEFAULT_LIMIT } from '@/config'
import { formatSongs } from '@/utils/song'

// 获取播放列表歌曲
export function getHotList() {
  return new Promise((resolve, reject) => {
    axios.get('/music/hots').then((resp) => {
      if (!Array.isArray(resp.data)) {
        reject(new Error('获取歌单详情失败'))
        return
      }
      let songs = formatSongs(resp.data)
      resolve(songs)
    })
  })
}
// 发送邮箱验证码
export function getEmailCode(emailUrl, username) {
  return axios.get('/getEmailCode', {
    params: {
      emailUrl,
      username
    }
  })
}

// 用户注册
export function toRegister(user) {
  return axios.post('/user/register', user)
}
// 用户登录
export function toLogin(user) {
  return axios.post('/user/login', user)
}

// 获取用户信息
export function getUserInfo(authorization) {
  return axios.post('/user/userInfo', authorization)
}

// 退出登录
export function logout() {
  return axios.post('/user/logout')
}
// 获取个人歌单歌曲列表
export function getPlaylistDetail(uid) {
  return new Promise((resolve, reject) => {
    axios.get('/sheet/' + uid).then((resp) => {
      if (resp.code === -1 && resp.msg == 'Token无效，您无权访问该接口') {
        resolve(resp)
        return
      }
      if (!Array.isArray(resp.data)) {
        reject(new Error('获取歌单详情失败'))
        return
      }
      let songs = formatSongs(resp.data)
      resolve(songs)
    })
  })
}

// 添加歌曲到歌单
export function toAddSheet(music) {
  return axios.post('/sheet', music)
}

// 取消喜欢歌曲
export function deleteMusicFormSheetByUid(uid, nameId) {
  return axios.delete(`/sheet/${uid}/${nameId}`)
}

// 判断歌曲是否已在喜欢列表中，用于下载歌曲
export function isLikeMusic(uid, nameId) {
  return axios.get('/sheet/islikemusic', {
    params: {
      uid,
      nameId
    }
  })
}

// 搜索歌曲
export function search(keywords) {
  return axios.get('/music/search', {
    params: {
      keywords
    }
  })
}

// 未使用接口
// 排行榜列表
// export function getToplistDetail() {
//   return axios.get('/toplist/detail')
// }

// 推荐歌单
// export function getPersonalized() {
//   return axios.get('/personalized')
// }

// 歌单详情
// export function getPlaylistDetail(id) {
//   return new Promise((resolve, reject) => {
//     axios
//       .get('/playlist/detail', {
//         params: { id }
//       })
//       .then(({ playlist }) => playlist || {})
//       .then((playlist) => {
//         const { trackIds, tracks } = playlist
//         if (!Array.isArray(trackIds)) {
//           reject(new Error('获取歌单详情失败'))
//           return
//         }
//         // 过滤完整歌单 如排行榜
//         if (tracks.length === trackIds.length) {
//           playlist.tracks = formatSongs(playlist.tracks)
//           resolve(playlist)
//           return
//         }
//         // 限制歌单详情最大 500
//         const ids = trackIds
//           .slice(0, 500)
//           .map((v) => v.id)
//           .toString()
//         getMusicDetail(ids).then(({ songs }) => {
//           playlist.tracks = formatSongs(songs)
//           resolve(playlist)
//         })
//       })
//   })
// }

// 搜索
// export function search(keywords, page = 0, limit = DEFAULT_LIMIT) {
//   return axios.get('/music/search', {
//     params: {
//       offset: page * limit,
//       limit: limit,
//       keywords
//     }
//   })
// }

// 热搜
// export function searchHot() {
//   return axios.get('/search/hot')
// }

// 获取用户歌单详情
// export function getUserPlaylist(uid) {
//   return axios.get('/user/playlist', {
//     params: {
//       uid
//     }
//   })
// }

// 获取歌曲详情
// export function getMusicDetail(ids) {
//   return axios.get('/song/detail', {
//     params: {
//       ids
//     }
//   })
// }

// 获取音乐是否可以用
// export function getCheckMusic(id) {
//   return axios.get('/check/music', {
//     params: {
//       id
//     }
//   })
// }

// 获取音乐地址
// export function getMusicUrl(id) {
//   return axios.get('/song/url', {
//     params: {
//       id
//     }
//   })
// }

// 获取歌词
// export function getLyric(id) {
//   const url = '/lyric'
//   return axios.get(url, {
//     params: {
//       id
//     }
//   })
// }

// 获取音乐评论
// export function getComment(id, page, limit = DEFAULT_LIMIT) {
//   return axios.get('/comment/music', {
//     params: {
//       offset: page * limit,
//       limit: limit,
//       id
//     }
//   })
// }
